<template>
  <div class="hello">
    <div  class="page"><img  alt="" class="bg" src="../assets/UploadFile/1/Img/2022620422433363721.jpg">
      <div  class="blk"><img  alt="" class="blk_logo" src="../assets/UploadFile/1/Img/2022620358521851191.png">
        <div  class="name">3D积木搭建手册</div>
        <div  class="button">
          <a  href="#/home" class="">
            <router-link to="/home">开启搭建之旅</router-link>
          </a>
        </div>
      </div>
      <footer  class="footer">

      </footer>
      <div  id="page-spinner" class="page-spinner" style="display: none;">
        <div class="vue-simple-spinner" style="margin: 0px auto; border-radius: 100%; border-width: 3px; border-style: solid; border-color: rgb(33, 150, 243) rgb(238, 238, 238) rgb(238, 238, 238); border-image: initial; width: 32px; height: 32px; animation: 0.8s linear 0s infinite normal none running vue-simple-spinner-spin;">
        </div>
        <div id="spinnertext" class="vue-simple-spinner-text" style="margin-top: 4px; color: rgb(255, 255, 255); font-size: 14px; text-align: center;">正在加载中...</div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/index.vue